import React, { createContext, useContext, useState } from 'react';

import { Storage } from 'src/utils/storage';
import { outrasUnidadesObj, UnidadeLogin } from '../types/accounts';

export interface Session {
  token: string;
  expiration: Date;
  user: User;
  condominio: string;
  goHome?: boolean;
}

export interface User {
  name: string;
  email: string;
  login: string;
  picture: string;
  unidade: string;
  outrasUnidades?: outrasUnidadesObj[];
  unidadeLogin?: UnidadeLogin;
}

interface IAuthContext {
  session: Session | undefined;
  authOn: (session: Session) => void;
  authOff: () => void;
}

const AuthContext = createContext<IAuthContext>(null as never);

function factoryConfig() {
  const [_, token, condominio] = window.location.hash.split('/');
  return { key: `session_${token}`, host: window.location.host, condominio };
}

export const authConfig = factoryConfig();

function saveSessionCookie(token?: string, expires?: Date) {
  if (token && expires) {
    document.cookie = `hub.votacao.token=${token}; expires=${expires}; domain=.hubert.com.br; path=/; secure`;
  } else {
    document.cookie = `hub.votacao.token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.hubert.com.br; path=/;`;
  }
}

export default ({ children }) => {
  const [session, setSession] = useState<Session | undefined>(
    Storage.get<Session>(authConfig.key)
  );

  const authOn = (params: Session) => {
    const expires = new Date(params.expiration);
    Storage.set(authConfig.key, params, expires);
    saveSessionCookie(params.token, expires);
    if (params.goHome) {
      setSession(params);
    }
  };

  const authOff = () => {
    Storage.remove(authConfig.key);
    saveSessionCookie(undefined);
    setSession(undefined);
  };

  return (
    <AuthContext.Provider value={{ session, authOn, authOff }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  return useContext(AuthContext);
}
